const Styles = {
    'FuzzySearchFilter': 'FuzzySearchFilter_FuzzySearchFilter--e0a2e20a',
    'searchIcon': 'FuzzySearchFilter_searchIcon--59fd4c8a',
    'cancel': 'FuzzySearchFilter_cancel--2630daff'
};

export default Styles;